import React, { Component } from "react";
import SVG from "react-inlinesvg";
import '../../assets/sass/pages/no-data.scss';

import ilsNoData from '../../assets/svg/ils/ils-no-data.svg';

class NoData extends Component {
    render() {
        return (
            <div className="no-data">
                <SVG src={ilsNoData}/>
                <h2>{this.props.title}</h2>
                <p>{this.props.description}</p>
            </div>
        );
    }
};

export default NoData;
